import axios from "axios";

axios.defaults.withCredentials = true;

const baseUrl = {
	base_url: process.env.REACT_APP_API_URL || "https://validaite.io/api"
};

/**** Login ****/
export const login = (data) => {
  const loginUserURL = baseUrl.base_url + "/login";
  const response = axios.post(loginUserURL, data);
  return response;
};

/**** Logout ****/
export const logout = () => {
  const logoutURL = baseUrl.base_url + "/logout";
  const response = axios.get(logoutURL);
  return response;
};

/**** Session Ping ****/
export const sessionPing = () => {
  const sessionPingURL = baseUrl.base_url + "/session-ping";
  const response = axios.get(sessionPingURL);
  return response;
};

/**** Application Setup ****/
export const getApplicationSetup = () => {
  return axios.get(baseUrl.base_url + "/application-setup");
};
export const saveApplicationSetup = (data) => {
  return axios.post(baseUrl.base_url + "/application-setup", data);
};
